<template>
  <div>
    <router-view v-if="$route.params.categoryId" />
    <Department v-else />
  </div>
</template>

<script>
import Department from "@/views/Department/Department.vue";

export default {
  name: "DepartmentAndCategoryView",
  components: { Department },
};
</script>
